import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    class: "tw-flex tw-gap-6 sf-below-2"
};
const _hoisted_2 = {
    class: "tw-inline"
};
const _hoisted_3 = {
    class: "tw-inline"
};
const _hoisted_4 = {
    class: "tw-inline"
};
const _hoisted_5 = {
    key: 0,
    class: "sf-table sf-table-hover tw-w-full"
};
const _hoisted_6 = {
    key: 0
};
const _hoisted_7 = {
    key: 1
};
const _hoisted_8 = {
    class: "tw-text-right"
};
const _hoisted_9 = {
    class: "tw-text-right"
};
export default /*@__PURE__*/ _defineComponent({
    ...{
        name: 'ExportDebugLog'
    },
    __name: 'export-debug-log',
    props: {
        debugLog: {}
    },
    setup (__props) {
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("dl", _hoisted_1, [
                    _createElementVNode("div", null, [
                        _cache[0] || (_cache[0] = _createElementVNode("dt", {
                            class: "tw-font-bold tw-inline"
                        }, "Ruby", -1)),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        _createElementVNode("dd", _hoisted_2, _toDisplayString(_ctx.debugLog.metadata.rubyVersion), 1)
                    ]),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    _createElementVNode("div", null, [
                        _cache[2] || (_cache[2] = _createElementVNode("dt", {
                            class: "tw-font-bold tw-inline"
                        }, "Memory", -1)),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("dd", _hoisted_3, _toDisplayString(_ctx.debugLog.metadata.initialMemoryMb) + "MB →\n        " + _toDisplayString(_ctx.debugLog.metadata.peakMemoryMb) + "MB peak →\n        " + _toDisplayString(_ctx.debugLog.metadata.finalMemoryMb) + "MB final\n      ", 1)
                    ]),
                    _cache[7] || (_cache[7] = _createTextVNode()),
                    _createElementVNode("div", null, [
                        _cache[4] || (_cache[4] = _createElementVNode("dt", {
                            class: "tw-font-bold tw-inline"
                        }, "Duration", -1)),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("dd", _hoisted_4, _toDisplayString(_ctx.debugLog.metadata.totalDurationSeconds) + "s", 1)
                    ])
                ]),
                _cache[15] || (_cache[15] = _createTextVNode()),
                _ctx.debugLog.steps.length ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
                    _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "#"),
                            _createTextVNode(),
                            _createElementVNode("th", null, "Type"),
                            _createTextVNode(),
                            _createElementVNode("th", null, "Title"),
                            _createTextVNode(),
                            _createElementVNode("th", {
                                class: "tw-text-right"
                            }, "Duration"),
                            _createTextVNode(),
                            _createElementVNode("th", {
                                class: "tw-text-right"
                            }, "Memory Δ")
                        ])
                    ], -1)),
                    _cache[14] || (_cache[14] = _createTextVNode()),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.debugLog.steps, (step)=>{
                            return _openBlock(), _createElementBlock("tr", {
                                key: step.index,
                                class: _normalizeClass({
                                    'sf-c-danger-light-1': step.status === 'running' || step.status === 'failed'
                                })
                            }, [
                                _createElementVNode("td", null, _toDisplayString(step.index), 1),
                                _cache[9] || (_cache[9] = _createTextVNode()),
                                _createElementVNode("td", null, _toDisplayString(step.type), 1),
                                _cache[10] || (_cache[10] = _createTextVNode()),
                                _createElementVNode("td", null, [
                                    _createTextVNode(_toDisplayString(step.title) + " ", 1),
                                    step.status === 'running' ? (_openBlock(), _createElementBlock("strong", _hoisted_6, "(killed)")) : _createCommentVNode("", true),
                                    _cache[8] || (_cache[8] = _createTextVNode()),
                                    step.status === 'failed' ? (_openBlock(), _createElementBlock("strong", _hoisted_7, "(failed)")) : _createCommentVNode("", true)
                                ]),
                                _cache[11] || (_cache[11] = _createTextVNode()),
                                _createElementVNode("td", _hoisted_8, _toDisplayString(step.status !== 'running' ? `${step.durationSeconds}s` : '—'), 1),
                                _cache[12] || (_cache[12] = _createTextVNode()),
                                _createElementVNode("td", _hoisted_9, _toDisplayString(step.status !== 'running' ? `${step.memoryDeltaMb}MB` : '—'), 1)
                            ], 2);
                        }), 128))
                    ])
                ])) : _createCommentVNode("", true)
            ], 64);
        };
    }
});
